import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from './ui/AppHeader';
import Toaster from './Toaster';

type HealthInfo = {
  status: string;
  service: string;
  env: string;
  version: string;
  git_sha?: string;
  git_branch?: string;
  built_at?: string;
};

export default function Layout() {
  const [health, setHealth] = useState<HealthInfo | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch('/health')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data) setHealth(data as HealthInfo);
      })
      .catch(() => {
        /* silent : pas critique */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-paper text-text-primary">
      <AppHeader />
      <main className="px-4 py-4 lg:px-6">
        <Outlet />
      </main>
      <Toaster />
      {health && <VersionBadge health={health} />}
    </div>
  );
}

function VersionBadge({ health }: { health: HealthInfo }) {
  const [open, setOpen] = useState(false);
  const sha = (health.git_sha || 'dev').slice(0, 8);
  const builtAt = health.built_at
    ? new Date(health.built_at).toLocaleString('fr-BE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : null;
  return (
    <div className="pointer-events-none fixed bottom-2 right-2 z-30">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="pointer-events-auto rounded-pill border border-rule bg-paper-elevated/90 px-2 py-0.5 font-mono text-[10px] text-text-tertiary backdrop-blur transition hover:border-accent/40 hover:text-accent-text"
        title="Version de l'application — clic pour détails"
      >
        v{health.version} · {sha}
      </button>
      {open && (
        <div className="pointer-events-auto mt-1 w-72 rounded-md border border-rule bg-paper-elevated p-3 text-[11px] shadow-md">
          <p className="mb-1.5 font-mono text-[10px] uppercase tracking-[0.5px] text-text-tertiary">
            Build
          </p>
          <ul className="space-y-1 text-text-secondary">
            <li>
              Service : <span className="font-mono text-text-primary">{health.service}</span>
            </li>
            <li>
              Environnement : <span className="font-mono text-text-primary">{health.env}</span>
            </li>
            <li>
              Version : <span className="font-mono text-text-primary">{health.version}</span>
            </li>
            <li>
              Branche :{' '}
              <span className="font-mono text-text-primary">{health.git_branch || '?'}</span>
            </li>
            <li>
              Commit : <span className="font-mono text-text-primary">{sha}</span>
            </li>
            {builtAt && (
              <li>
                Buildé le : <span className="font-mono text-text-primary">{builtAt}</span>
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
